/*
  Diwali fireworks for the whole storefront. bs-header loads this while Festive theme is Diwali.
  - A short show (about 3 seconds) after the page loads: once per visit, or on every page with a
    smaller show after the first one, depending on the header's Fireworks setting.
  - A small crackling burst from the button whenever something is added to the cart.
  Skipped for reduced-motion and data-saver users. The canvas never takes clicks and is removed as
  soon as the last spark fades. Styles: .bs-diwali-fireworks in assets/bs-header-diwali.css.
*/
(function () {
  if (window.bsDiwaliFireworks) return;
  window.bsDiwaliFireworks = true;

  var script = document.currentScript || document.querySelector('script[data-diwali-fireworks]');
  var showMode = (script && script.getAttribute('data-show')) || 'off';
  var cartBurst = !!script && script.getAttribute('data-cart-burst') === 'true';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduceMotion || saveData) return;

  var SESSION_KEY = 'bs-diwali-show-seen';
  // Warm, saturated Diwali colours: they stay visible on the light pages and the dark banners, and
  // don't disappear into the navy packs the way blues do.
  var COLORS = ['#ffb703', '#fb8500', '#ff5d2a', '#e63946', '#ff3d7f', '#f72585', '#ffd60a', '#2dc653'];
  var SPARK_COLORS = ['#fff4c2', '#ffd166'];
  var GRAVITY = 240;

  var canvas = null;
  var ctx = null;
  var width = 0;
  var height = 0;
  var particles = [];
  var rockets = [];
  var queue = [];
  var rafId = 0;
  var lastTime = 0;
  var clock = 0;

  function compact() {
    return window.innerWidth < 750;
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function resize() {
    if (!canvas) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function start() {
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'bs-diwali-fireworks';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      resize();
      window.addEventListener('resize', resize);
    }
    if (!rafId) {
      lastTime = performance.now();
      rafId = requestAnimationFrame(frame);
    }
  }

  function stop() {
    cancelAnimationFrame(rafId);
    rafId = 0;
    window.removeEventListener('resize', resize);
    if (canvas) canvas.remove();
    canvas = null;
    ctx = null;
    particles = [];
    rockets = [];
    queue = [];
    clock = 0;
  }

  function dot(x, y, size, color, alpha) {
    ctx.fillStyle = color;
    ctx.globalAlpha = alpha * 0.25;
    ctx.beginPath();
    ctx.arc(x, y, size * 2.4, 0, Math.PI * 2);
    ctx.fill();
    ctx.globalAlpha = alpha;
    ctx.beginPath();
    ctx.arc(x, y, size, 0, Math.PI * 2);
    ctx.fill();
    ctx.globalAlpha = 1;
  }

  function burst(x, y, options) {
    var colorA = pick(COLORS);
    var colorB = pick(COLORS);
    // A quick flash of light where the burst opens.
    particles.push({ x: x, y: y, vx: 0, vy: 0, life: 1, decay: 5, size: options.flash, color: '#fff3c4', crackle: false, cracked: true });
    for (var i = 0; i < options.count; i++) {
      var angle = (Math.PI * 2 * i) / options.count + rand(-0.12, 0.12);
      var speed = options.power * rand(0.45, 1);
      particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 1,
        decay: rand(0.55, 0.95),
        size: rand(1.8, 3.2),
        color: i % 3 === 0 ? colorB : colorA,
        crackle: options.crackle,
        cracked: false
      });
    }
  }

  // The "crack" at the end of a burst: a few tiny white-gold sparks that scatter and blink out.
  function crackle(p) {
    for (var i = 0; i < 3; i++) {
      particles.push({
        x: p.x,
        y: p.y,
        vx: rand(-60, 60),
        vy: rand(-60, 60),
        life: 0.6,
        decay: rand(1.6, 2.4),
        size: rand(0.8, 1.3),
        color: pick(SPARK_COLORS),
        crackle: false,
        cracked: true
      });
    }
  }

  function launch(spec) {
    var startX = spec.x + rand(-30, 30);
    rockets.push({
      sx: startX,
      sy: height + 6,
      tx: spec.x,
      ty: spec.y,
      x: startX,
      y: height + 6,
      t: 0,
      d: rand(0.65, 0.9),
      burst: spec.burst
    });
  }

  function frame(now) {
    var dt = Math.min((now - lastTime) / 1000, 0.05);
    lastTime = now;
    clock += dt;

    while (queue.length && queue[0].at <= clock) launch(queue.shift());

    // Fade the previous frame instead of clearing it, which leaves short light trails.
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
    ctx.fillRect(0, 0, width, height);
    ctx.globalCompositeOperation = 'source-over';

    for (var r = rockets.length - 1; r >= 0; r--) {
      var rocket = rockets[r];
      rocket.t += dt;
      var k = Math.min(rocket.t / rocket.d, 1);
      var ease = 1 - (1 - k) * (1 - k);
      var fromX = rocket.x;
      var fromY = rocket.y;
      rocket.x = rocket.sx + (rocket.tx - rocket.sx) * ease;
      rocket.y = rocket.sy + (rocket.ty - rocket.sy) * ease;
      // Draw the step as a line so the rising rocket leaves a continuous streak, not dots.
      ctx.strokeStyle = '#ffc94d';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(fromX, fromY);
      ctx.lineTo(rocket.x, rocket.y);
      ctx.stroke();
      dot(rocket.x, rocket.y, 1.8, '#ffe8a3', 1);
      if (k >= 1) {
        rockets.splice(r, 1);
        burst(rocket.tx, rocket.ty, rocket.burst);
      }
    }

    var drag = 1 - 1.8 * dt;
    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.vx *= drag;
      p.vy = p.vy * drag + GRAVITY * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.life -= p.decay * dt;
      if (p.crackle && !p.cracked && p.life < 0.4) {
        p.cracked = true;
        crackle(p);
      }
      if (p.life <= 0) {
        particles.splice(i, 1);
        continue;
      }
      // Dying sparks flicker, which reads as crackling.
      var alpha = p.life < 0.35 && Math.random() < 0.35 ? p.life * 0.3 : p.life;
      dot(p.x, p.y, p.size, p.color, alpha);
    }

    if (queue.length || rockets.length || particles.length) {
      rafId = requestAnimationFrame(frame);
    } else {
      stop();
    }
  }

  function playShow(rocketCount) {
    var small = compact();
    var count = small ? Math.max(rocketCount - 2, 2) : rocketCount;
    for (var i = 0; i < count; i++) {
      // Spread the bursts across three columns of the upper screen so they don't pile up.
      var column = i % 3;
      queue.push({
        at: clock + i * 0.42 + rand(0, 0.15),
        x: ((column + rand(0.2, 0.8)) / 3) * window.innerWidth,
        y: rand(0.14, 0.42) * window.innerHeight,
        burst: {
          count: small ? 38 : 56,
          power: small ? 210 : 300,
          flash: small ? 7 : 9,
          crackle: i % 3 === 2
        }
      });
    }
    queue.sort(function (a, b) { return a.at - b.at; });
    start();
  }

  function scheduleShow() {
    var seen = false;
    try {
      seen = window.sessionStorage.getItem(SESSION_KEY) === '1';
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      // Storage blocked: treat every page as the first one.
    }
    if (window.Shopify && window.Shopify.designMode) seen = false;

    var rocketCount = 0;
    if (showMode === 'first_visit' && !seen) rocketCount = 6;
    if (showMode === 'every_page') rocketCount = seen ? 3 : 6;
    if (!rocketCount) return;

    function go() {
      if (!document.hidden) {
        playShow(rocketCount);
        return;
      }
      document.addEventListener('visibilitychange', function onVisible() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVisible);
        setTimeout(function () { playShow(rocketCount); }, 400);
      });
    }

    // Wait for the page to finish loading so the show never competes with the first paint.
    if (document.readyState === 'complete') {
      setTimeout(go, 700);
    } else {
      window.addEventListener('load', function () { setTimeout(go, 700); }, { once: true });
    }
  }

  // Add-to-cart bursts. Every add-to-cart in this theme (and the Razorpay side cart) goes through
  // /cart/add, so watch for that request instead of hooking each button, and burst from the button
  // the shopper last pressed.
  var lastPress = null;

  function remember(event) {
    var target = event.target && event.target.closest ? event.target.closest('button, [type="submit"], [role="button"]') : null;
    if (!target) return;
    lastPress = { el: target, x: event.clientX, y: event.clientY, t: performance.now() };
  }

  function pressPoint() {
    if (!lastPress) return null;
    if (lastPress.el.isConnected) {
      var rect = lastPress.el.getBoundingClientRect();
      if (rect.width && rect.bottom > 0 && rect.top < window.innerHeight) {
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      }
    }
    return lastPress.x || lastPress.y ? { x: lastPress.x, y: lastPress.y } : null;
  }

  if (cartBurst && 'PerformanceObserver' in window) {
    document.addEventListener('pointerdown', remember, true);
    document.addEventListener('click', function (event) {
      if (event.detail === 0) remember(event);
    }, true);

    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.name.indexOf('/cart/add') === -1) return;
          if (entry.responseStatus >= 400) return;
          if (!lastPress || performance.now() - lastPress.t > 8000) return;
          var point = pressPoint();
          lastPress = null;
          if (!point) return;
          burst(point.x, point.y, { count: compact() ? 24 : 30, power: compact() ? 160 : 200, flash: 7, crackle: true });
          start();
        });
      }).observe({ type: 'resource' });
    } catch (error) {
      // Resource timing unavailable: no cart bursts.
    }
  }

  scheduleShow();
})();
